import script from "./BenefitTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitTemp.vue?vue&type=script&setup=true&lang=js"

import "./BenefitTemp.vue?vue&type=style&index=0&id=e3f977fe&lang=css"

const __exports__ = script;

export default __exports__